export const CHANGE_CONVERSATION = 'CHANGE_CONVERSATION';

export const changeConversation = (user: String) => ({
    type: CHANGE_CONVERSATION,
    payload: user,
});
